import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";
import { discountPriceItems, discountPriceOnArrearsZero } from "../../utils/helpers";

const borderColor = "#90e5fc";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontSize: 12,
    backgroundColor: "#F1F1F1",
  },
  col: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    backgroundColor: "#F1F1F1",
  },
  description: {
    width: "20%",
    textAlign: "center",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 40,
    fontFamily: "NotoNastaliqUrdu",
    fontSize: 14,
    fontWeight: "bold",
  },
  total: {
    width: "20%",
    textAlign: "left",
    paddingLeft: 20,
    paddingTop: 2,
    fontSize: 12,
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  totalGrand: {
    width: "20%",
    textAlign: "left",
    paddingLeft: 20,
    paddingTop: 2,
    fontSize: 14,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    color: "green",
  },
  sign: {
    width: "60%",
    borderRightWidth: 1,
    borderRightColor: borderColor,
    fontFamily: "NotoNastaliqUrdu",
    textAlign: "right",
    paddingTop: 2,
    fontSize: 14,
    fontWeight: "bold",
    marginRight: "3rem",
  },
});

const InvoiceTableFooter = ({ items, invoice }) => {

  const Arrear =invoice.pay? Number.parseFloat(invoice?.ArrearData):Number.parseFloat(invoice?.ArrearPayment)
  //**********discount ********/
  let discount = 0;
  const similarIds = discountPriceItems.filter((item) => {
    const matchingItem = invoice.items?.find(
      (orderItem) => orderItem.id+"" === item.id+""
    );
    if (matchingItem) {
      discount = discount + item.discount * matchingItem.quantity;
    }
    return matchingItem !== undefined;
  });
  if (!discountPriceOnArrearsZero){
    discount=0
  }

  let returns = Number(invoice.returnAmount);
  let total = invoice?.bill
    ? invoice?.bill
    : items
        ?.map((item) => {
          let price = parseFloat(item.price.toString().replace(/,/g, ""));
          return item.quantity * price;
        })
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0) ||
      0;
  let currentTotal = total + Number(invoice?.delivery_charges) - returns;
  let grossTotal = currentTotal+Number(Arrear);
  let discountAmount = grossTotal - discount;
  let payments = invoice?.payment ? Number(invoice.payment) : 0;
 

  return (
    <>
      <View>
        <View style={styles.row}>
          <Text style={styles.total}>
            {Number.parseInt(total).toLocaleString()}
          </Text>
          <Text style={styles.description}>ٹوٹل بل</Text>
          <Text style={styles.sign}> </Text>
        </View>
        {invoice?.delivery_charges> 0 && (
        <View style={styles.col}>
          <Text style={styles.total}>
            {Number.parseInt(invoice?.delivery_charges || 0).toLocaleString()}
          </Text>
          <Text style={styles.description}>ڈیلیوری چارجز</Text>
          <Text style={styles.sign}></Text>
        </View>
        )}
        {Number.parseInt(returns) > 0 && (
          <View style={styles.col}>
            <Text style={styles.total}>
              {Number.parseInt(returns).toLocaleString()}
            </Text>
            <Text style={styles.description}>واپسی</Text>
            <Text style={styles.sign}></Text>
          </View>
        )}
        <View style={styles.col}>
          <Text style={styles.total}>
            {Number.parseInt(currentTotal).toLocaleString()}
          </Text>
          <Text style={styles.description}>آج کا ٹوٹل</Text>
          <Text style={styles.sign}></Text>
        </View>
        {Number.parseInt(Arrear) > 0 && (
          <View style={styles.col}>
            <Text style={styles.total}>
              {Number.parseInt(Arrear).toLocaleString()}
            </Text>
            <Text style={styles.description}>بقایا جات</Text>
            <Text style={styles.sign}></Text>
          </View>
        )}
        {Number.parseInt(Arrear) == 0 &&
          similarIds &&
          similarIds?.length > 0 && discount>0 && (
            <View style={styles.row}>
              <Text style={styles.total}>
                {Number.parseInt(discount).toLocaleString()}
              </Text>
              <Text style={styles.description}>رعایت </Text>
              <Text style={styles.sign}></Text>
            </View>
          )}
        {Number.parseInt(Arrear) <= 0 ? (
          <View style={styles.row}>
            <Text style={styles.totalGrand}>
              {Number.parseInt(discountAmount).toLocaleString()}
            </Text>
            <Text style={styles.description}> مجموعی ٹوٹل</Text>
            {Number.parseInt(payments) == 0 && (
              <Text style={styles.sign}>
                {/* _______________:ڈیلیوری دستخط:_______________وصول دستخط */}
              </Text>
            )}
          </View>
        ) : (
          <View style={styles.row}>
            <Text style={styles.totalGrand}>
              {Number.parseInt(grossTotal).toLocaleString()}
            </Text>
            <Text style={styles.description}>مجموعی ٹوٹل</Text>
            {Number.parseInt(payments) == 0 && (
              <Text style={styles.sign}>
                {/* _______________:ڈیلیوری دستخط:_______________وصول دستخط */}
              </Text>
            )}
          </View>
        )}
        {Number.parseInt(invoice?.payment) > 0 && (
          <View style={styles.row}>
            <Text style={styles.total}>
              {Number.parseInt(payments).toLocaleString()}
            </Text>
            <Text style={styles.description}>ادائیگی</Text>
            <Text style={styles.sign}></Text>
          </View>
        )}

        {Number.parseInt(payments) != 0 &&
          Number.parseInt(invoice.balance) != 0 && (
            <View style={styles.row}>
              <Text style={styles.total}>
                {Number.parseInt(invoice.balance).toLocaleString()}
              </Text>
              <Text style={styles.description}> بقایا</Text>
              <Text style={styles.sign}></Text>
            </View>
          )}
        {Number.parseInt(payments) != 0 &&
          Number.parseInt(invoice.balance) == 0 &&
          Number.parseInt(invoice.advancePayment) > 0 && (
            <View style={styles.row}>
              <Text style={styles.total}>
                {Number.parseInt(invoice.advancePayment).toLocaleString()}
              </Text>
              <Text style={styles.description}> اڈوانس</Text>
              <Text style={styles.sign}></Text>
            </View>
          )}
      </View>
    </>
  );
};

export default InvoiceTableFooter;
